import { FC, useCallback, useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import {
  DadosAbertosList,
  DadosAbertosProps,
  OpenDataItensProps,
} from "./openData-list";
import { getServerData } from "../../util/get-server-data";
import { openData } from "../../types/openData";

export const DadosAbertosListContainer: FC = () => {
  let history = useHistory();

  const [isMounted, setIsMounted] = useState(false);

  const [openDataList, setOpenDataList] = useState<OpenDataItensProps[]>([]);
  const [openDataListFiltered, setOpenDataListFiltered] = useState<
    OpenDataItensProps[]
  >([]);

  const onClickCard = useCallback(
    (slug) => {
      history.push(`/dados/${slug}`);
    },
    [history]
  );

  const onClickSearch = useCallback(
    (filter) => {
      const filtered = openDataList.filter(
        ({ text }) => text?.toUpperCase()?.indexOf(filter?.toUpperCase()) !== -1
      );

      setOpenDataListFiltered(filtered);
    },
    [openDataList]
  );

  useEffect(() => {
    if (!isMounted) {
      setIsMounted(true);

      const parsedData = getServerData("openDataList", []);

      if (parsedData?.length === 0) {
        setOpenDataList(openData);
        setOpenDataListFiltered(openData);
      } else {
        setOpenDataList(parsedData);
      }
    }
  }, [isMounted]);

  const newsProps: DadosAbertosProps = {
    onClick: onClickCard,
    onClickSearch,
    itens: openDataListFiltered,
  };

  return <DadosAbertosList {...newsProps} />;
};
